import React from 'react';
import { BarSpinner } from '@kvika/spinner';
import Entity from './Entity';
import { StyledSpinnerContainer, StyledEntitiesContainer } from '../styles/SelectEntityStyles';
var SelectEntities = function (_a) {
    var entities = _a.entities, selectButtonText = _a.selectButtonText, ssnText = _a.ssnText, onEntitySelect = _a.onEntitySelect, isLoading = _a.isLoading, className = _a.className, testId = _a.testId;
    return isLoading ? (React.createElement(StyledSpinnerContainer, null,
        React.createElement(BarSpinner, null))) : (React.createElement(StyledEntitiesContainer, { className: className, "data-testid": testId }, entities &&
        entities.map(function (entity) {
            return (React.createElement(Entity, { entity: entity, onEntitySelect: onEntitySelect, selectButtonText: selectButtonText, ssnText: ssnText, key: entity.ssn, testId: testId }));
        })));
};
export default SelectEntities;
//# sourceMappingURL=SelectEntities.js.map